<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>题库管理</el-breadcrumb-item>
      <el-breadcrumb-item>题目管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区 -->
    <el-card class="box-card">
      <div slot="header" class="flexContainer">
        <span class="cardHeader">题目管理</span>
        <div style="float:right;">
          <el-button type="primary" icon="el-icon-plus" size="normal" @click="handleAdd">添加题目</el-button>
          <el-upload
            style="display: inline-block; margin-left: 10px;"
            :action="importUrl"
            :headers="uploadHeaders"
            :show-file-list="false"
            :on-success="handleImportSuccess"
            :on-error="handleImportError"
            :before-upload="beforeImportUpload"
            accept=".xlsx,.xls,.zip">
            <el-button type="success" icon="el-icon-upload2" size="normal">导入</el-button>
          </el-upload>
          <el-button type="warning" icon="el-icon-download" size="normal" @click="handleDownloadTemplate" style="margin-left: 10px;">下载模板</el-button>
        </div>
      </div>

      <!-- 搜索区 -->
      <div class="search-bar">
        <el-form :model="queryInfo" :inline="true" size="small" label-width="80px">
          <el-form-item label="所属分类">
            <el-select v-model="queryInfo.category" placeholder="全部分类" clearable style="width: 200px;" @change="getList">
              <el-option v-for="item in categoryList" :key="item._id" :label="item.name" :value="item._id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="题型">
            <el-select v-model="queryInfo.type" placeholder="全部题型" clearable style="width: 150px;" @change="getList">
              <el-option label="选择题" value="choice"></el-option>
              <el-option label="判断题" value="judge"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
            <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 数据表格 -->
      <el-table :data="list" border stripe v-loading="loading">
        <el-table-column type="index" label="#" width="60"></el-table-column>
        <el-table-column label="题型" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.type === 'choice' ? 'primary' : 'success'" size="small">
              {{ scope.row.type === 'choice' ? '选择题' : '判断题' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="选择类型" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.type === 'judge'">-</span>
            <el-tag v-else :type="scope.row.choiceType === 'single' ? '' : 'warning'" size="small">
              {{ scope.row.choiceType === 'single' ? '单选' : '多选' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="题目内容" min-width="250">
          <template slot-scope="scope">
            <div v-if="scope.row.content && scope.row.content.contentType === 'image'" class="question-thumb">
              <el-image
                :src="base + scope.row.content.value"
                :preview-src-list="[base + scope.row.content.value]"
                fit="cover"
                style="width: 60px; height: 60px; border-radius: 4px;">
              </el-image>
            </div>
            <div v-else class="question-text">{{ scope.row.content ? scope.row.content.value : '' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="所属分类" width="140">
          <template slot-scope="scope">
            <span>{{ getCategoryName(scope.row.category) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="180">
          <template slot-scope="scope">{{ scope.row.createDate | dateFormat }}</template>
        </el-table-column>
        <el-table-column label="操作" width="180" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="danger" size="mini" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-card>

    <!-- 添加/编辑对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="720px"
      :close-on-click-modal="false"
      top="30px"
      @closed="resetForm">
      <el-form ref="formRef" :model="form" :rules="rules" label-width="100px">
        <!-- 题型 -->
        <el-form-item label="题型" prop="type">
          <el-radio-group v-model="form.type" @change="handleTypeChange">
            <el-radio label="choice">选择题</el-radio>
            <el-radio label="judge">判断题</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 选择类型（仅选择题显示） -->
        <el-form-item v-if="form.type === 'choice'" label="选择类型" prop="choiceType">
          <el-radio-group v-model="form.choiceType" @change="handleChoiceTypeChange">
            <el-radio label="single">单选</el-radio>
            <el-radio label="multiple">多选</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 所属分类 -->
        <el-form-item label="所属分类" prop="category">
          <el-select v-model="form.category" placeholder="请选择分类" style="width: 100%;">
            <el-option v-for="item in categoryList" :key="item._id" :label="item.name" :value="item._id"></el-option>
          </el-select>
        </el-form-item>

        <!-- 题目内容类型 -->
        <el-form-item label="内容类型" prop="contentContentType">
          <el-radio-group v-model="form.contentContentType" @change="handleContentContentTypeChange">
            <el-radio label="text">文本</el-radio>
            <el-radio label="image">图片</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 题目内容 - 文本模式 -->
        <el-form-item v-if="form.contentContentType === 'text'" label="题目内容" prop="contentValue">
          <el-input
            type="textarea"
            v-model="form.contentValue"
            :rows="4"
            placeholder="请输入题目内容">
          </el-input>
        </el-form-item>

        <!-- 题目内容 - 图片模式 -->
        <el-form-item v-if="form.contentContentType === 'image'" label="题目内容" prop="contentValue">
          <el-upload
            :action="uploadUrl"
            :headers="uploadHeaders"
            list-type="picture-card"
            :on-success="handleContentImageSuccess"
            :on-remove="handleContentImageRemove"
            :file-list="contentImageFileList"
            :limit="1"
            :class="{'hide-upload': contentImageFileList.length >= 1}"
            accept="image/*">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>

        <!-- 选项列表 - 选择题 -->
        <el-form-item v-if="form.type === 'choice'" label="选项列表" prop="options">
          <div class="options-container">
            <div v-for="(option, index) in form.options" :key="index" class="option-row">
              <span class="option-label">{{ optionLabels[index] }}.</span>
              <!-- 选项类型切换 -->
              <el-radio-group v-model="option.contentType" size="mini" style="margin-right: 10px;" @change="clearOptionValue(index)">
                <el-radio-button label="text">文本</el-radio-button>
                <el-radio-button label="image">图片</el-radio-button>
              </el-radio-group>
              <!-- 文本选项 -->
              <el-input
                v-if="option.contentType === 'text'"
                v-model="option.value"
                placeholder="请输入选项内容"
                style="flex: 1;">
              </el-input>
              <!-- 图片选项 -->
              <div v-if="option.contentType === 'image'" class="option-upload">
                <el-upload
                  :action="uploadUrl"
                  :headers="uploadHeaders"
                  list-type="picture-card"
                  :on-success="(res, file, fileList) => handleOptionImageSuccess(index, res, file, fileList)"
                  :on-remove="(file, fileList) => handleOptionImageRemove(index, file, fileList)"
                  :file-list="option.fileList || []"
                  :limit="1"
                  :class="{'hide-upload': (option.fileList || []).length >= 1}"
                  accept="image/*">
                  <i class="el-icon-plus"></i>
                </el-upload>
              </div>
              <!-- 删除选项按钮 -->
              <el-button
                v-if="form.options.length > 2"
                type="danger"
                icon="el-icon-delete"
                circle
                size="mini"
                style="margin-left: 10px;"
                @click="removeOption(index)">
              </el-button>
            </div>
            <el-button
              v-if="form.options.length < 6"
              type="primary"
              size="small"
              icon="el-icon-plus"
              @click="addOption"
              style="margin-top: 10px;">
              添加选项
            </el-button>
          </div>
        </el-form-item>

        <!-- 选项列表 - 判断题 -->
        <el-form-item v-if="form.type === 'judge'" label="选项列表">
          <div class="options-container">
            <div class="option-row judge-option">
              <el-tag type="success">A. 正确</el-tag>
            </div>
            <div class="option-row judge-option">
              <el-tag type="danger">B. 错误</el-tag>
            </div>
          </div>
        </el-form-item>

        <!-- 正确答案 - 单选 -->
        <el-form-item v-if="form.type === 'choice' && form.choiceType === 'single'" label="正确答案" prop="answer">
          <el-radio-group v-model="form.answerSingle">
            <el-radio v-for="(option, index) in form.options" :key="index" :label="index">
              {{ optionLabels[index] }}
            </el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 正确答案 - 多选 -->
        <el-form-item v-if="form.type === 'choice' && form.choiceType === 'multiple'" label="正确答案" prop="answer">
          <el-checkbox-group v-model="form.answerMultiple">
            <el-checkbox v-for="(option, index) in form.options" :key="index" :label="index">
              {{ optionLabels[index] }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <!-- 正确答案 - 判断题 -->
        <el-form-item v-if="form.type === 'judge'" label="正确答案" prop="answer">
          <el-radio-group v-model="form.answerJudge">
            <el-radio :label="0">正确</el-radio>
            <el-radio :label="1">错误</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="handleSubmit">{{ submitting ? '提交中...' : '确定' }}</el-button>
      </span>
    </el-dialog>

    <!-- 图片预览 -->
    <el-image
      v-show="false"
      ref="imageViewer"
      :src="previewImageUrl"
      :preview-src-list="previewImageList">
    </el-image>
  </div>
</template>

<script>
export default {
  name: 'QuestionList',
  data () {
    // 验证正确答案
    const validateAnswer = (rule, value, callback) => {
      if (this.form.type === 'choice' && this.form.choiceType === 'single') {
        if (this.form.answerSingle === '' || this.form.answerSingle === null || this.form.answerSingle === undefined) {
          callback(new Error('请选择正确答案'))
        } else {
          callback()
        }
      } else if (this.form.type === 'choice' && this.form.choiceType === 'multiple') {
        if (!this.form.answerMultiple || this.form.answerMultiple.length === 0) {
          callback(new Error('请选择正确答案'))
        } else {
          callback()
        }
      } else if (this.form.type === 'judge') {
        if (this.form.answerJudge === '' || this.form.answerJudge === null || this.form.answerJudge === undefined) {
          callback(new Error('请选择正确答案'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }

    return {
      // 列表数据
      list: [],
      total: 0,
      loading: false,
      // 分类列表
      categoryList: [],
      // 查询条件
      queryInfo: {
        category: '',
        type: '',
        pagenum: 1,
        pagesize: 20
      },
      // 对话框可见性
      dialogVisible: false,
      // 是否编辑模式
      isEdit: false,
      // 当前编辑的题目ID
      currentId: '',
      // 提交状态
      submitting: false,
      // 图片基础路径
      base: '',
      // 选项标签
      optionLabels: ['A', 'B', 'C', 'D', 'E', 'F'],
      // 表单数据
      form: {
        type: 'choice',
        choiceType: 'single',
        category: '',
        contentContentType: 'text',
        contentValue: '',
        options: [
          { contentType: 'text', value: '', fileList: [] },
          { contentType: 'text', value: '', fileList: [] },
          { contentType: 'text', value: '', fileList: [] },
          { contentType: 'text', value: '', fileList: [] }
        ],
        answerSingle: '',
        answerMultiple: [],
        answerJudge: ''
      },
      // 题目内容图片文件列表
      contentImageFileList: [],
      // 表单验证规则
      rules: {
        type: [
          { required: true, message: '请选择题型', trigger: 'change' }
        ],
        choiceType: [
          { required: true, message: '请选择选择类型', trigger: 'change' }
        ],
        category: [
          { required: true, message: '请选择所属分类', trigger: 'change' }
        ],
        contentContentType: [
          { required: true, message: '请选择内容类型', trigger: 'change' }
        ],
        contentValue: [
          { required: true, message: '请填写题目内容', trigger: 'blur' }
        ],
        answer: [
          { validator: validateAnswer, trigger: 'change' }
        ]
      },
      // 上传配置
      uploadUrl: this.$http.defaults.baseURL + 'upload',
      uploadHeaders: {
        authorization: window.sessionStorage.getItem('token'),
        Accept: 'application/json'
      },
      // 导入上传地址
      importUrl: this.$http.defaults.baseURL + 'tiku/question/import',
      // 图片预览
      previewImageUrl: '',
      previewImageList: []
    }
  },
  computed: {
    dialogTitle () {
      return this.isEdit ? '编辑题目' : '添加题目'
    }
  },
  created () {
    this.base = window.sessionStorage.getItem('base') || ''
    this.getCategoryList()
    this.getList()
  },
  methods: {
    // ========== 数据获取 ==========

    /** 获取题目列表 */
    async getList () {
      this.loading = true
      try {
        const params = {
          pagenum: this.queryInfo.pagenum,
          pagesize: this.queryInfo.pagesize
        }
        if (this.queryInfo.category) params.category = this.queryInfo.category
        if (this.queryInfo.type) params.type = this.queryInfo.type

        const { data: res } = await this.$http.get('tiku/question/list', { params })
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.list = res.data.list
        this.total = res.data.total
      } catch (error) {
        this.$message.error('获取题目列表失败')
      } finally {
        this.loading = false
      }
    },

    /** 获取分类列表 */
    async getCategoryList () {
      try {
        const { data: res } = await this.$http.get('tiku/category/list')
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.categoryList = res.data.list
      } catch (error) {
        this.$message.error('获取分类列表失败')
      }
    },

    /** 根据分类ID获取分类名称 */
    getCategoryName (categoryData) {
      const categoryId = categoryData._id
      if (!categoryId) return '-'
      const category = this.categoryList.find(item => item._id === categoryId)
      return category ? category.name : '-'
    },

    // ========== 搜索与分页 ==========

    /** 重置查询条件 */
    resetQuery () {
      this.queryInfo = {
        category: '',
        type: '',
        pagenum: 1,
        pagesize: 20
      }
      this.getList()
    },

    /** 每页数量变更 */
    handleSizeChange (val) {
      this.queryInfo.pagesize = val
      this.getList()
    },

    /** 页码变更 */
    handleCurrentChange (val) {
      this.queryInfo.pagenum = val
      this.getList()
    },

    // ========== 弹窗操作 ==========

    /** 点击添加按钮 */
    handleAdd () {
      this.isEdit = false
      this.currentId = ''
      this.dialogVisible = true
    },

    /** 点击编辑按钮 */
    handleEdit (row) {
      this.isEdit = true
      this.currentId = row._id

      // 填充表单基本字段
      this.form.type = row.type
      this.form.choiceType = row.choiceType || 'single'
      this.form.category = row.category
      this.form.contentContentType = row.content ? row.content.contentType : 'text'
      this.form.contentValue = row.content ? row.content.value : ''

      // 处理题目内容图片
      if (this.form.contentContentType === 'image' && this.form.contentValue) {
        this.contentImageFileList = [{ url: this.base + this.form.contentValue }]
      } else {
        this.contentImageFileList = []
      }

      // 处理选项
      if (row.type === 'choice' && row.options && row.options.length > 0) {
        this.form.options = row.options.map(opt => ({
          contentType: opt.contentType || 'text',
          value: opt.value || '',
          fileList: opt.contentType === 'image' && opt.value ? [{ url: this.base + opt.value }] : []
        }))
      } else {
        // 判断题或无选项时使用默认选项
        this.form.options = [
          { contentType: 'text', value: '', fileList: [] },
          { contentType: 'text', value: '', fileList: [] },
          { contentType: 'text', value: '', fileList: [] },
          { contentType: 'text', value: '', fileList: [] }
        ]
      }

      // 处理答案
      if (row.type === 'judge') {
        this.form.answerJudge = row.answer && row.answer.length > 0 ? row.answer[0] : ''
        this.form.answerSingle = ''
        this.form.answerMultiple = []
      } else if (row.type === 'choice' && row.choiceType === 'multiple') {
        this.form.answerMultiple = row.answer || []
        this.form.answerSingle = ''
        this.form.answerJudge = ''
      } else {
        this.form.answerSingle = row.answer && row.answer.length > 0 ? row.answer[0] : ''
        this.form.answerMultiple = []
        this.form.answerJudge = ''
      }

      this.dialogVisible = true
    },

    /** 点击删除按钮 */
    async handleDelete (row) {
      const confirmResult = await this.$confirm(
        '确定要删除该题目吗？',
        '确认删除',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(() => {})

      if (confirmResult !== 'confirm') return this.$message.info('操作已取消')

      try {
        const { data: res } = await this.$http.delete(`tiku/question/remove/${row._id}`)
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.$message.success('删除成功')
        this.getList()
      } catch (error) {
        this.$message.error('删除操作失败')
      }
    },

    // ========== 表单联动 ==========

    /** 题型变更处理 */
    handleTypeChange (val) {
      if (val === 'judge') {
        // 判断题重置选项和答案
        this.form.choiceType = 'single'
        this.form.answerSingle = ''
        this.form.answerMultiple = []
        this.form.answerJudge = ''
      } else {
        // 选择题恢复默认选项
        if (this.form.options.length < 2) {
          this.form.options = [
            { contentType: 'text', value: '', fileList: [] },
            { contentType: 'text', value: '', fileList: [] },
            { contentType: 'text', value: '', fileList: [] },
            { contentType: 'text', value: '', fileList: [] }
          ]
        }
        this.form.answerJudge = ''
      }
    },

    /** 选择类型变更处理 */
    handleChoiceTypeChange () {
      // 切换单选/多选时清空答案
      this.form.answerSingle = ''
      this.form.answerMultiple = []
    },

    /** 内容类型变更处理 */
    handleContentContentTypeChange () {
      this.form.contentValue = ''
      this.contentImageFileList = []
    },

    /** 清除指定选项的值 */
    clearOptionValue (index) {
      this.form.options[index].value = ''
      this.form.options[index].fileList = []
    },

    /** 添加选项 */
    addOption () {
      this.form.options.push({ contentType: 'text', value: '', fileList: [] })
    },

    /** 删除选项 */
    removeOption (index) {
      this.form.options.splice(index, 1)
      // 清空答案中超出范围的索引
      if (this.form.choiceType === 'single' && this.form.answerSingle >= this.form.options.length) {
        this.form.answerSingle = ''
      }
      if (this.form.choiceType === 'multiple') {
        this.form.answerMultiple = this.form.answerMultiple.filter(i => i < this.form.options.length)
      }
    },

    // ========== 上传处理 ==========

    /** 题目内容图片上传成功 */
    handleContentImageSuccess (res, file, fileList) {
      if (res.meta.status !== 200) {
        this.$message.error(res.meta.msg || '上传失败')
        return
      }
      this.form.contentValue = res.data.url
      this.contentImageFileList = fileList
    },

    /** 题目内容图片删除 */
    handleContentImageRemove (file, fileList) {
      this.form.contentValue = ''
      this.contentImageFileList = fileList
    },

    /** 选项图片上传成功 */
    handleOptionImageSuccess (index, res, file, fileList) {
      if (res.meta.status !== 200) {
        this.$message.error(res.meta.msg || '上传失败')
        return
      }
      this.form.options[index].value = res.data.url
      this.form.options[index].fileList = fileList
    },

    /** 选项图片删除 */
    handleOptionImageRemove (index, file, fileList) {
      this.form.options[index].value = ''
      this.form.options[index].fileList = fileList
    },

    // ========== 导入相关 ==========

    /** 导入上传前校验 */
    beforeImportUpload (file) {
      const validTypes = [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-excel',
        'application/zip',
        'application/x-zip-compressed'
      ]
      const isLt20M = file.size / 1024 / 1024 < 20

      if (!validTypes.includes(file.type) && !file.name.match(/\.(xlsx|xls|zip)$/i)) {
        this.$message.error('只能上传 xlsx、xls 或 zip 文件!')
        return false
      }
      if (!isLt20M) {
        this.$message.error('上传文件大小不能超过 20MB!')
        return false
      }
      return true
    },

    /** 导入成功回调 */
    handleImportSuccess (res) {
      if (res.meta && res.meta.status !== 200) {
        return this.$message.error(res.meta.msg || '导入失败')
      }
      const data = res.data
      let msg = `导入完成：共 ${data.total} 条，成功 ${data.success} 条，失败 ${data.fail} 条`
      if (data.skippedCount) {
        msg += `\n另有 ${data.skippedCount} 条因分类不存在被跳过`
      }
      if (data.fail > 0 || data.skippedCount) {
        this.$notify({
          title: '导入结果',
          message: msg + (data.hint ? '\n' + data.hint : ''),
          type: 'warning',
          duration: 8000
        })
      } else {
        this.$message.success(msg)
      }
      this.getList()
    },

    /** 导入失败回调 */
    handleImportError () {
      this.$message.error('导入失败，请检查文件格式')
    },

    /** 下载模板 */
    async handleDownloadTemplate () {
      try {
        const res = await this.$http.get('tiku/question/template', { responseType: 'blob' })
        const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = '题库导入模板.xlsx'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(link.href)
      } catch (error) {
        this.$message.error('下载模板失败')
      }
    },

    // ========== 提交表单 ==========

    /** 提交表单 */
    async handleSubmit () {
      const valid = await this.$refs.formRef.validate().catch(() => false)
      if (!valid) return

      // 验证选项（选择题至少2个有内容的选项）
      if (this.form.type === 'choice') {
        const filledOptions = this.form.options.filter(opt => opt.value)
        if (filledOptions.length < 2) {
          return this.$message.warning('选择题至少需要2个有内容的选项')
        }
      }

      this.submitting = true
      try {
        // 构建提交数据
        const submitData = {
          type: this.form.type,
          category: this.form.category,
          content: {
            contentType: this.form.contentContentType,
            value: this.form.contentValue
          }
        }

        // 选择题附加字段
        if (this.form.type === 'choice') {
          submitData.choiceType = this.form.choiceType
          submitData.options = this.form.options.map(opt => ({
            contentType: opt.contentType,
            value: opt.value
          }))
          // 设置答案
          if (this.form.choiceType === 'single') {
            submitData.answer = [this.form.answerSingle]
          } else {
            submitData.answer = [...this.form.answerMultiple]
          }
        } else {
          // 判断题固定选项
          submitData.options = [
            { contentType: 'text', value: '正确' },
            { contentType: 'text', value: '错误' }
          ]
          submitData.answer = [this.form.answerJudge]
        }

        let res
        if (this.isEdit) {
          res = await this.$http.put(`tiku/question/modify/${this.currentId}`, submitData)
        } else {
          res = await this.$http.post('tiku/question/add', submitData)
        }

        if (res.data.meta.status !== 200) {
          return this.$message.error(res.data.meta.msg)
        }

        this.$message.success(this.isEdit ? '修改成功' : '添加成功')
        this.dialogVisible = false
        this.getList()
      } catch (error) {
        this.$message.error('操作失败')
      } finally {
        this.submitting = false
      }
    },

    /** 重置表单 */
    resetForm () {
      this.form = {
        type: 'choice',
        choiceType: 'single',
        category: '',
        contentContentType: 'text',
        contentValue: '',
        options: [
          { contentType: 'text', value: '', fileList: [] },
          { contentType: 'text', value: '', fileList: [] },
          { contentType: 'text', value: '', fileList: [] },
          { contentType: 'text', value: '', fileList: [] }
        ],
        answerSingle: '',
        answerMultiple: [],
        answerJudge: ''
      }
      this.contentImageFileList = []
      this.$refs.formRef && this.$refs.formRef.resetFields()
    }
  }
}
</script>

<style lang="less" scoped>
.flexContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cardHeader {
  font-size: 18px;
  font-weight: bold;
}

.search-bar {
  margin-bottom: 15px;
  padding: 20px 20px 0;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.el-pagination {
  margin-top: 15px;
}

.question-text {
  font-size: 14px;
  color: #303133;
  line-height: 1.6;
  // 文本超出显示省略号
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.question-thumb {
  display: flex;
  align-items: center;
}

.options-container {
  width: 100%;
}

.option-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  .option-label {
    font-weight: bold;
    font-size: 14px;
    color: #303133;
    margin-right: 10px;
    min-width: 24px;
  }

  .option-upload {
    flex: 1;
  }
}

.judge-option {
  margin-bottom: 8px;
}

.hide-upload /deep/ .el-upload--picture-card {
  display: none;
}
</style>
